<template>
  <div class="eventComp_mode_20 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsId="currSportsDetail.sportsId"
        :tabType="tabType"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableGroupIndexArr="tableGroupIndexArr"
        :tableGroupRowBgArr="tableGroupRowBgArr"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用：射击【男子25米手枪速射 | 混合团体决赛】等出场名单； 单个表格 通过行来展示组的概念 (例如：组1+每组成员)等 展开一级 （普通表格，不带展开行）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_20',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_20 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_20',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 11.1,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      tableGroupIndexArr: [],
      tableGroupRowBgArr: ['groupBg_subMain05_row'], // 设置：【金牌争夺赛 | 组1】等等整行合并单元格的背景色
      renderModeList: [
        {
          modeName: '',
          variableColWidthVw: [],
          sportsIdArr: ['SHO'],
        },
      ],
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isTabType) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isTabType === this.tabType
              ) {
                this.currModeObj = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }

        let data = []
        let groupItem = Object.keys(this.datas.data)
        let tableGroupIndexArr = []
        groupItem.forEach((group) => {
          data.push({
            [this.datas.table_head[0].map_key_arr[0]]: group,
          })
          tableGroupIndexArr.push(data.length - 1)
          data = [].concat(data, this.datas.data[group])
        })
        let datas = {
          data,
          table_head: this.datas.table_head,
        }
        console.debug('tableGroupIndexArr:', tableGroupIndexArr)
        this.tableGroupIndexArr = tableGroupIndexArr
        this.computedModeData(JSON.parse(JSON.stringify(datas)))
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data, this.currModeObj)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns
        let customColumn = null
        let competitorType = this.competitorType
        if (['SHO'].includes(this.currSportsDetail.sportsId)) {
          competitorType = 'A'
        }
        if (competitorType === 'T') {
          customColumn = {
            prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
            label: '国家/地区',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        } else {
          let playerProp =
            'playerName-playerLogo-playerGender-teamLogo-teamName'
          let playerClassName = 'columnPlayerGroupClass'
          if (
            ['FEN'].includes(this.currSportsDetail.sportsId) &&
            this.tabType === 'localData'
          ) {
            playerProp = `${playerProp}-${this.currSportsDetail.sportsId}`
            playerClassName = `${playerClassName}-${this.currSportsDetail.sportsId}`
          }
          customColumn = {
            prop: playerProp, //fristColumnPropArr.join('-'),
            label: '运动员',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: playerClassName, //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        }
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []

          if (this.currModeObj.tableCellDefaultWidthVw) {
            this.tableCellDefaultWidthVw =
              this.currModeObj.tableCellDefaultWidthVw
          }
          let widthVw = this.tableCellDefaultWidthVw

          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
              // 特殊列
              tableColumnData.push(customColumn)
            } else {
              console.debug('widthVw:', widthVw)
              let className = ''
              let prop = item.colKey
              tableColumnData.push({
                prop: prop,
                label: item.colTitle,
                // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? this.tableCellDefaultWidthVw / 2
                //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? 'expandTdClassName'
                //   : '', //单独定制的头部样式class
                widthVw,
                className,
                selected: '',
              })
            }
          }
          this.defaultWidthVwNum = tableColumnData.length - 1 //减去这1列[运动员]
          this.tableColumnData = tableColumnData
        }
        this.tableData = data.data.map((rowData) => {
          return rowData
        })
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData, this.tableColumnData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
